module.exports = __webpack_public_path__ + "static/media/WAULTx.14e266cb.svg";